import { find } from "@kluntje/js-utils/lib/dom-helpers";
import { WECLazyImage } from "Components/wec-e-lazy-image/wec-e-lazy-image";
import { RenderLazyImageArgs } from "Components/wec-e-lazy-image/wec-e-lazy-image.types";
import { WECImageGalleryLightbox } from "Components/wec-m-image-gallery-lightbox/wec-m-image-gallery-lightbox";
import { waitForInitialization } from "Helper/componentHelper/waitForInitialization";
import { render } from "lit-html";

class ImageLightboxService {
  private getImageRenderArgs(image: WECLazyImage): RenderLazyImageArgs {
    return {
      src: image.imgSrc,
      srcset: image.imgSrcSet,
      loadingPlaceholder: image.loadingPlaceholder,
      alt: image.imgAlt,
      aspectRatio: image.imgAspectRatio,
    };
  }

  async openLightbox(images: Array<WECLazyImage>, activeImageId: number) {
    const imageRenderArgs = images.map(image => this.getImageRenderArgs(image));

    const renderImageGalleryLightbox = await this.loadTemplate();

    const renderWrapper = document.createElement("div");
    render(renderImageGalleryLightbox({ images: imageRenderArgs, activeImageId }), renderWrapper);

    const lightbox = find<WECImageGalleryLightbox>(renderWrapper, ".wec-m-image-gallery-lightbox");
    if (lightbox === null) return;
    document.body.appendChild(lightbox);
    await waitForInitialization(lightbox);
    lightbox.open();
  }

  async loadTemplate() {
    const { renderImageGalleryLightbox } = await import(
      "Components/wec-m-image-gallery-lightbox/wec-m-image-gallery-lightbox.template"
    );
    return renderImageGalleryLightbox;
  }
}

export default new ImageLightboxService();
